import { gql } from '@apollo/client';
import { CRM_EMAIL_TEMPLATE_FIELDS } from './queries';

export const CREATE_CRM_EMAIL_TEMPLATE = gql`
    mutation CreateCrmEmailTemplate($input: CreateCrmEmailTemplateInput!) {
        createCrmEmailTemplate(input: $input) {
            ${CRM_EMAIL_TEMPLATE_FIELDS}
        }
    }
`;

export const UPDATE_CRM_EMAIL_TEMPLATE = gql`
    mutation UpdateCrmEmailTemplate($input: UpdateCrmEmailTemplateInput!) {
        updateCrmEmailTemplate(input: $input) {
            ${CRM_EMAIL_TEMPLATE_FIELDS}
        }
    }
`;

export const DELETE_CRM_EMAIL_TEMPLATE = gql`
    mutation DeleteCrmEmailTemplate($id: String!) {
        deleteCrmEmailTemplate(id: $id) {
            _id
            name
        }
    }
`;

export const DUPLICATE_CRM_EMAIL_TEMPLATE = gql`
    mutation DuplicateCrmEmailTemplate($input: DuplicateCrmEmailTemplateInput!) {
        duplicateCrmEmailTemplate(input: $input) {
            ${CRM_EMAIL_TEMPLATE_FIELDS}
        }
    }
`;

export const SEND_CRM_TEMPLATE_TEST_EMAIL = gql`
    mutation SendCrmTemplateTestEmail($input: SendCrmTemplateTestEmailInput!) {
        sendCrmTemplateTestEmail(input: $input) {
            crmMessageId
            status
            reason
        }
    }
`;
